import React from 'react';

import styles from './styles.module.scss';

interface TagType {
    tagName: string;
}

interface Props {
    tags: TagType[];
    className?: string;
    title?: string;
    titleClassName?: string;
}

const Tag = ({ tagName }: TagType) => {
    return <div className={styles.tag}>{tagName}</div>;
};

const DiscoverMore = (props: Props) => {
    return (
        <div className={`${styles.container} ${props.className}`}>
            {props.title && <div className={`${styles.title} ${props.titleClassName}`}>{props.title}</div>}
            {props.tags.map((tag, idx) => (
                <Tag key={`discover-tag-${idx}`} {...tag} />
            ))}
        </div>
    );
};

DiscoverMore.defaultProps = {
    className: '',
    title: '',
    titleClassName: '',
};

export default DiscoverMore;
